import { render, staticRenderFns } from "./salesFact.vue?vue&type=template&id=0a4c2261"
import script from "./salesFact.vue?vue&type=script&lang=js"
export * from "./salesFact.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports